module.exports = __webpack_public_path__ + "static/media/logo-kienguru.0cbbea08.png";